/**
 * Price used when a screen shows the current share price or a value at that price.
 * Only a real positive phase price is accepted. A missing session must not
 * substitute $25, $10, $5, or $1.
 *
 * @param {unknown} value
 * @returns {number | null}
 */
export function acceptDisplayedSharePrice(value) {
  if (value == null || value === '') return null
  const price = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(price) || price <= 0) return null
  return price
}

/**
 * Phase row used by the share purchase screen.
 * The active sale must be phase 3 or later and at least $20 per share.
 * Numeric database strings are accepted. A missing or cheaper row is not.
 * This does not write a share or a balance.
 *
 * @param {unknown} phase
 * @returns {object | null}
 */
export function acceptPurchasePhase(phase) {
  if (!phase || typeof phase !== 'object') return null
  const row = /** @type {Record<string, unknown>} */ (phase)
  if (row.id == null || row.id === '') return null
  const phaseNumber = Number(row.phase_number)
  const price = acceptDisplayedSharePrice(row.price_per_share)
  if (!Number.isFinite(phaseNumber) || price == null) return null
  if (phaseNumber < 3 || price < 20) return null
  return {
    ...row,
    phase_number: phaseNumber,
    price_per_share: price,
  }
}
